import { createCrudPage } from './factories/crud-page.js';

/**
 * Legacy backend reads `type` as a query param; not part of shared AppContext.
 * @typedef {import('../contracts/context.js').AppContext & { type?: string }} LegacyArticlePermanentContext
 */

export default createCrudPage({
  title: 'Permanent Articles',
  basePath: '/article-permanent',
  reorderable: true,
  columns: [
    { key: 'articletype_name', label: 'Article Type' },
    { key: 'article_title', label: 'Article' },
  ],
  fields: [
    { key: 'type', label: 'Article Type', type: 'async-select',
      optionsUrl: '/article-types/options' },
    { key: 'article_id', label: 'Article', type: 'async-select',
      optionsUrl: '/articles/options', dependsOn: ['type'] },
  ],
  fetchParams: (ctx) => {
    const legacy = /** @type {LegacyArticlePermanentContext} */ (ctx.services.context);
    return { type: legacy.type };
  },
});
